<template>
    <div class="sino-wealth" >
        <!-- ============= 顶部菜单栏 ============= -->
        <el-header class="sw-header" style="padding: 0;">
          <sw-header></sw-header>
        </el-header>

        <!-- ============= 主页面 ============= -->
        <el-main class="sw-main">
          <router-view></router-view>
        </el-main>

        <!-- ============= 底部工具栏 ============= -->
        <el-footer class="sw-footer">
          <sw-footer></sw-footer>
        </el-footer>
    </div>
</template>

<script>
    import SwHeader from '@/components/header'//大写字母在标签里采取“-小写”
    import SwFooter from '@/components/footer'

    export default {
        name: "home",//不知道干哈的

        mounted: function () {

        },

        data() {
          return {
          }
        },

        methods: {

        },

        components: {
          SwHeader,
          SwFooter
        }
    }
</script>

<style>
     html,body {/*! autoprefixer: off */ margin: 0;padding-top: 0;min-height: 100%;height: 0; /*! autoprefixer: on */}
    .sw-header {/*! autoprefixer: off */  height: 107px !important;padding: 0; /*! autoprefixer: on */}
    .sw-main {/*! autoprefixer: off */ width: 100%;padding: 0;  /*! autoprefixer: on */}
    .el-main {/*! autoprefixer: off */ overflow: inherit;padding: 0 /*! autoprefixer: on */}
    .sw-footer { width: 100%;padding: 0 !important; }
</style>



// WEBPACK FOOTER //
// src/pages/home.vue